import React from "react";
import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./PagamentosTable.css";

const formaPagamento = (tipo) => {
  const mapa = {
    bank_transfer: "PIX",
    account_money: "Saldo em conta",
    CASH: "Espécie",
    debit_card: "Débito",
    credit_card: "Crédito",
    1: "Crédito",
    11: "PIX",
    8: "Débito",
  };
  return mapa[tipo] || "-";
};

const moeda = (valor) => new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
}).format(Number(valor || 0));

const PagamentosTable = ({ listCanals = [] }) => (
  <table className="table table-bordered pagamentos-responsive-table">
    <thead>
      <tr>
        <th>Data</th>
        <th>Forma de pagamento</th>
        <th>Valor</th>
        <th>Identificador</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      {listCanals.map((canal, index) => (
        <tr key={canal?.id || canal?.mercadoPagoId || index}>
          <td data-label="Data">{moment(canal?.data)?.format("DD/MM/YYYY HH:mm:ss")}</td>
          <td data-label="Forma">{formaPagamento(canal?.tipo)}</td>
          <td data-label="Valor" className="pagamento-valor">{moeda(canal?.valor)}</td>
          <td data-label="Identificador" className="pagamento-id">{canal?.mercadoPagoId || "-"}</td>
          <td data-label="Status">
            <OverlayTrigger
              placement="bottom"
              popperConfig={{ modifiers: [{ name: "preventOverflow", enabled: false }] }}
              overlay={<Tooltip id={`tooltip-pagamento-${index}`} style={{ zIndex: 1050 }}>{canal?.motivoEstorno || "Sem motivo registrado"}</Tooltip>}
            >
              <span className={`badge ${canal?.estornado ? "bg-danger" : "bg-success"}`}>
                {canal?.estornado ? "Estornado" : "Recebido"}
              </span>
            </OverlayTrigger>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default PagamentosTable;
